import { createStore } from 'redux';
import rootReducer from '../Reducer';

import { loadState } from './localStorage';

const persistedState = loadState();

const configureStore = () => createStore(rootReducer, persistedState);


export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js